'use client';
import { useEffect, useState } from 'react';

import classes from '../../shared/PageContent/ProductListing/product-listing.module.scss';
import SRPFeaturedCategories from '../SRPFeaturedCategories/SRPFeaturedCategories';
import Heading from '@next-app/components/elements/Heading/Heading';
import {
  chunkCarouselItem,
  findObject,
  getWebContentsReq,
} from '@next-app/utils/PDPHelper';
import { PDPCarouselsContent } from '@next-app/interface/PDP/PDPCarouselsContent';
import { CarouselProducts } from '@next-app/interface/PDP/PDPRecentlyViewedProducts';

import ProductRecommendation from '@next-app/components/shared/ProductRecommendation/ProductRecommendation';
import { useSelector } from 'react-redux';
import {
  selectFeatureToggles,
  selectIsStoreSelected,
} from '@next-app/lib/features/InitSelectors';

const ZeroResultsPage = ({ data }: any): React.JSX.Element => {
  const [webContentRes, setWebContentRes] = useState<PDPCarouselsContent>();
  const [chunkSize, setChunkSize] = useState(4); // Default chunk size is 4
  const { sessionInfo } = useSelector((state: any) => state.init);
  const isStoreSelected = useSelector(selectIsStoreSelected);
  const featureToggles = useSelector(selectFeatureToggles);
  const enableStoreOnlyItems = featureToggles?.enableStoreOnlyItems;
  const { sessionInfo: { profile: { gsaUser = false } = {} } = {} } =
    sessionInfo || {};
  let ZeroResultsPageData;

  try {
    ZeroResultsPageData = data?.contents?.[0]?.mainContent?.[0]?.contents?.find(
      (item: any) => item['@type'] === 'PageContent-ZeroSearchResult',
    );
  } catch (e) {
    console.log('Error occurred finding PageContent-ZeroSearchResult');
    ZeroResultsPageData = {};
  }

  useEffect(() => {
    const fetchWebContent = async () => {
      const prevRcs = localStorage.getItem('rr_rcs') || '';
      const rcs = (prevRcs && JSON.parse(prevRcs)?.value) || '';
      const res = await getWebContentsReq(
        'zrp',
        rcs,
        ZeroResultsPageData?.originalTerms[0],
      );
      setWebContentRes(res);
    };

    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setChunkSize(2);
      } else {
        setChunkSize(4);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    fetchWebContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const RecsProduct = findObject(
    webContentRes?.content,
    'PageContent-ProductRecs',
  );

  const { products: recommendations = [] } = RecsProduct[0] || {};
  const chunkedRecommendations: CarouselProducts[][] = chunkCarouselItem(
    recommendations ?? [],
    chunkSize,
  );

  return (
    <div className={classes['srp-container']}>
      <div
        className={`fw-bold mx-auto ${classes['srp-container-box']}`}
        dangerouslySetInnerHTML={{
          __html: ZeroResultsPageData?.zeroSearchInfoString,
        }}
      ></div>
      <div className={classes['srp-categories']}>
        <SRPFeaturedCategories data={ZeroResultsPageData} />
      </div>
      <div className={classes['new-trending-wrapper']}>
        <div className="text-center mb-3">
          <Heading customClass={classes['new-trending-title']} tagName="2">
            {RecsProduct[0]?.recommendationTitle}
          </Heading>
        </div>
        <div className={classes['trending-items-wrap']}>
          {chunkedRecommendations.map((group, groupIndex) => (
            <div key={`recommendationSlide-${groupIndex}`}>
              <ProductRecommendation
                key={`carouselSlide-${groupIndex}`}
                group={group}
                classnameItem={classes['carousel-items-no-result']}
                classnameItemName=""
                enableStoreOnlyItems={enableStoreOnlyItems}
                isStoreSelected={isStoreSelected}
                gsaUser={gsaUser}
                justifyClass=""
                classnameRegPrice={`ll-fs-13 ${classes['no-result-reg-price']}`}
                classnameImage={`d-inline-block ${classes['no-result-item-image']}`}
              ></ProductRecommendation>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ZeroResultsPage;
